import React from 'react';
import { Button } from './ui/Button';
import { cn } from '../lib/utils';

const PreviewButton = ({ 
  onClick, 
  disabled = false, 
  tooltip = "Preview templates", 
  className = "", 
  style = {},
  isDark = false
}) => {
  return (
    <Button
      variant="orange"
      isDark={isDark}
      onClick={onClick}
      disabled={disabled}
      title={tooltip}
      className={cn('px-[12px] py-[8px] text-[16px]' ,className)}
      style={style}
      icon={
        <div
          className="w-[16px] h-[16px] shrink-0"
          style={{
            backgroundColor: isDark ? '#000000' : '#ffffff',
            WebkitMaskImage: "url('/assets/icons/viewdata.svg')",
            WebkitMaskRepeat: 'no-repeat',
            WebkitMaskSize: 'contain',
            WebkitMaskPosition: 'center',
            maskImage: "url('/assets/icons/viewdata.svg')",
            maskRepeat: 'no-repeat',
            maskSize: 'contain',
            maskPosition: 'center',
            transition: 'background-color 0.2s ease'
          }}
          aria-hidden="true"
        />
      }
    >
      Preview
    </Button>
  );
};

export default PreviewButton;
